import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiClient } from '@/lib/api/client';
import { getApiErrorMessage } from '@/lib/utils/api-errors';
import type { ConfirmPickupPayload, ConfirmPickupResult } from '../types/pickup.types';

interface ApiData<T> {
  data: T;
}

export function useConfirmPickup() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ orderId, token, code }: ConfirmPickupPayload) => {
      const response = await apiClient.post<ApiData<ConfirmPickupResult>>(
        `/order/pickup/${orderId}/confirm`,
        { token, code }
      );
      return response.data?.data ?? null;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pending-pickups'] });
      toast.success(t('orders.pickupConfirmation.success'));
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error));
    },
  });
}
